
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        modelValue: {
            type: String,
            required: true,
        },
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        "update:modelValue"(value: string) {
            return true;
        },
    },
    setup() {
        return {
            tabs: [
                {
                    label: "录音室专辑",
                    value: "a0",
                },
                {
                    label: "单曲",
                    value: "asingle",
                },
                {
                    label: "精选/合集",
                    value: "a1",
                },
                {
                    label: "现场",
                    value: "a6",
                },
                {
                    label: "合作",
                    value: "a20",
                },
            ],
        };
    },
});
